import _pt from "prop-types";
import React from 'react';
import MenuLinks from './MenuLinks';
import classnames from 'classnames';

var Menu = function Menu(props) {
  var classes = classnames('hc-c-menu', {
    'hc-c-menu--open': props.open
  });
  return /*#__PURE__*/React.createElement("div", {
    id: "hc-c-menu",
    hidden: !props.open,
    className: classes
  }, props.submenuTop, props.beforeLinks, props.links && /*#__PURE__*/React.createElement(MenuLinks, {
    links: props.links
  }), props.submenuBottom);
};

Menu.propTypes = {
  submenuTop: _pt.node,
  submenuBottom: _pt.node,

  /**
     * Nodes to be rendered before the links column
     */
  beforeLinks: _pt.node,

  /**
     * When the menu is collapsed, passing in "open" will
     * expand it and make it visible.
     */
  open: _pt.bool
};
export default Menu;